<template>
    <mdb-view class="hm-gradient">
        <vue-flux
                :options="vfOptions"
                :images="vfImages"
                :transitions="vfTransitions"
                :captions="vfCaptions"
                style="z-index: -1; height: 100%"
                ref="slider">

            <template v-slot:preloader>
                <flux-preloader/>
            </template>
        </vue-flux>

        <mdb-mask class="gradient full-bg-img d-flex justify-content-center align-items-center">
            <mdb-container>
                <mdb-row class="chead">
                    <div class="white-text text-center text-md-left col-md-6 mt-xl-5 mt-md-5 pt-md-5 pb-sm-0 mb-sm-0 animated fadeInLeft">
                        <h1 class="h1-responsive font-weight-bold text-uppercase mt-sm-5">AI and Machine Learning for
                            Army Applications</h1>
                        <hr class="hr-light"/>
                        <h6 class="mb-4">Smart Material Discovery with Scientists-in-the-Loop by Worcester Polytechnic
                            Institute in Collaboration with Army Research Lab</h6>
                        <router-link to="/#aboutus"><mdb-btn outline="white">Learn More</mdb-btn></router-link>
                    </div>
                    <mdb-col md="6" xl="5" class="mt-xl-5 mt-lg-5 pt-lg-5 mt-md-5 pt-md-5 mt-l-0 mt-sm-0 pt-sm-0 animated fadeInRight text-center">
                        <mdb-row class="py-4">
                            <mdb-col>
                                <img src="../assets/wpi-logo-min.png" class="img-fluid"
                                     style="max-width: 75%;display: inline-block!important;"/>
                            </mdb-col>
                        </mdb-row>
                        <mdb-row class="py-2 mt-sm-0">
                            <div class="text-center" style=""><img src="../assets/arl-logo-min.png" class="img-fluid"
                                                                   style="max-width: 75%;display: inline-block!important;"/>
                            </div>
                        </mdb-row>
                    </mdb-col>
                </mdb-row>
            </mdb-container>
        </mdb-mask>
    </mdb-view>
</template>

<script>
    import {
        VueFlux,
        // FluxCaption,
        // FluxControls,
        // FluxIndex,
        // FluxPagination,
        FluxPreloader,

    } from 'vue-flux';


    import {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbView,
        mdbMask,
        mdbBtn,
    } from 'mdbvue';

    export default {
        name: 'Intro',
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbView,
            mdbMask,
            mdbBtn,
            VueFlux,
            // FluxCaption,
            // FluxControls,
            // FluxIndex,
            // FluxPagination,
            FluxPreloader,
        },
        data: () => ({
            vfOptions: {
                autoplay: true
            },
            vfImages: [require('@/assets/background/bg-min.jpg'), require('@/assets/background/bg1-min.jpg'), require('@/assets/background/bg2-min.jpg')],
            vfTransitions: ['slide'],
            vfCaptions: [
                'Caption for image 1',
                'Caption for image 2',
                'Caption for image 3',
            ],
        }),
    }
</script>

<style scoped>
    .view {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        height: calc(100vh - 0px);
    }

    .gradient {
        background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
        background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    }

    h6 {
        line-height: 1.7;
    }

    .hm-gradient .full-bg-img {
        background: rgba(42, 27, 161, 0.7);
        background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    }

    @media (max-width: 700px) {
        .chead {
            padding-top: 100px;
        }

    }
</style>
